// src/features/whatsapp/pages/LowBalanceAlertPage.tsx
// Re-cableado a lealify-base (Inc11): recordatorio al cliente cuando su saldo queda bajo tras un canje (evento low_balance).
import React from 'react';
import { BatteryLow } from 'lucide-react';
import EventMessageEditor from '../components/EventMessageEditor';

const LowBalanceAlertPage: React.FC = () => (
  <EventMessageEditor
    eventKey="low_balance"
    title="Aviso de Saldo Bajo"
    subtitle="Recuérdale al cliente que vuelva cuando, tras un canje, su saldo de puntos queda bajo"
    icon={<BatteryLow className="h-5 w-5 sm:h-6 sm:w-6 mr-2 text-emerald-500" />}
    feature="Aviso de Saldo Bajo"
    defaultTemplate="@nombre, te quedan @puntos puntos en @negocio. ¡Te esperamos para sumar más!"
    variables={[
      { key: '@nombre', label: 'Nombre del cliente', example: 'María' },
      { key: '@puntos', label: 'Saldo restante del cliente', example: '5', aliases: ['@total', '@saldo'] },
      { key: '@negocio', label: 'Nombre de tu negocio', example: 'tu negocio', aliases: ['@marca'] },
    ]}
    extraField={{
      settingKey: 'threshold',
      kind: 'number',
      label: 'Umbral de saldo bajo (puntos)',
      placeholder: '0',
      help: 'Si tras un canje el saldo del cliente queda en este valor o menos, se le envía el recordatorio.',
    }}
    enabledHint={{ on: 'El cliente recibe un recordatorio cuando su saldo queda bajo', off: 'Activar para recordar a clientes con saldo bajo' }}
    stepGuide={{
      description: 'Cuando un cliente canjea y su saldo queda en el umbral o por debajo, el sistema le envía este recordatorio por WhatsApp (una sola vez hasta que vuelva a sumar).',
      steps: ['Cliente canjea', 'Saldo queda bajo', 'WhatsApp de recordatorio'],
    }}
    requirementsReady="Todo listo — tus clientes con saldo bajo recibirán un recordatorio para volver"
    allowImage
  />
);

export default LowBalanceAlertPage;
